export default "__VITE_ASSET__c4889da0__"